import { jsx as _jsx } from "react/jsx-runtime";
export const IconSvg = ({ children, role = 'img', size = 24, strokeWidth = 1, viewBox, ...props }) => {
    return (_jsx("svg", { fill: "none", focusable: false, height: size, role: role, strokeWidth: strokeWidth, viewBox: viewBox, width: size, ...props, children: children }));
};
//# sourceMappingURL=IconSvg.js.map